import { Box, Card, Typography } from '@mui/material';
import { fShortenNumber } from '../../../utils/formatNumber';
import PropTypes from 'prop-types';
import ArrowButton from '../../../components/button-arrow/ArrowButton';

export default function AppSingleStat({
    title,
    subtitle,
    total,
    gradient = 'primary',
    sx,
    onArrowClick,
    ...other
}) {
    return (
        <Card
            sx={{
                p: 2.5,
                pl: 0,
                boxShadow: 0,
                textAlign: 'left',
                backgroundColor: (theme) => theme.palette.background.paper,
                ...sx
            }}
            {...other}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography
                    variant="h3"
                    sx={{ background: (theme) => theme.palette.gradients[gradient], WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}
                >
                    {fShortenNumber(total)}
                </Typography>
                <ArrowButton variant="dark" onClick={() => onArrowClick()}/>

            </Box>

            <Typography variant="subtitle1" sx={{ color: 'text.default' }}>
                {title}
            </Typography>
            <Typography variant="caption" sx={{ color: 'text.disabled' }} >
                {subtitle}
            </Typography>
        </Card>
    );
}
AppSingleStat.propTypes = {
    onArrowClick: PropTypes.func,
    gradient: PropTypes.oneOf(['primary', 'secondary', 'info']),
    title: PropTypes.string,
    subtitle: PropTypes.string,
    total: PropTypes.number,
    sx: PropTypes.object
};
